import React, { useEffect, useState } from 'react'
import BarcodeGenerator from '@components/Barcode/index'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { clearOrderData } from '@slice/mainSlice.js'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { config } from '../../config'
import { Image, Empty } from 'antd'
import { http } from '@services/http.js'
import './index.css'
import {
	formatNumberWithSpaces,
	numberWithSpacesIntl,
} from '@utils/numberWithSpaces'
import { useQuery } from '@tanstack/react-query'
import { generateImage } from '@utils/generateShapeImage'

const MarshrutPage = () => {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [data, setData] = useState(null)
	const [selectedImage, setSelectedImage] = useState(null)
	const [path, setPath] = useState([])
	const [docNum, setDocNum] = useState('')

	const { ordersPage } = useSelector((state) => state.main)

	useEffect(() => {
		setTimeout(() => {
			window.print()
		}, 1000)
	}, [])

	useEffect(() => {
		const storedData = sessionStorage.getItem('invoicesMarshrutData')
		const purchaseOrderDocNum = sessionStorage.getItem(
			'purchaseOrderDocNumMarshrutData',
		)
		if (storedData) {
			const resData = JSON.parse(storedData)
			const docNum = JSON.parse(purchaseOrderDocNum)
			setData(resData)
			setDocNum(docNum)
			console.log('data = ', resData)
		}
	}, [])

	return (
		<div className="print-container p-2 bg-white font-semibold text-black font-sans">
			<div className="border-b ">
				<div className="flex justify-between items-center">
					<div>
						<BarcodeGenerator docNum={data?.docNum} />
					</div>
					<div className="text-lg">
						<span className="font-semibold">Менеджер:</span>{' '}
						{data?.slpName}
					</div>
				</div>

				<p className="font-semibold text-2xl text-center">
					Поступления {data?.docNumPrefix} из заказа {docNum}
				</p>

				<div className="flex items-center justify-between  mb-5 text-lg ">
					<div className="mt-5 flex flex-col gap-3">
						<p className="font-semibold">Информация о заказе</p>
						<p>
							<span className="font-semibold">Дата:</span>{' '}
							{moment(data?.docDate).format('DD.MM.YYYY')}
						</p>
					</div>

					<div className="text-right flex flex-col gap-3">
						<p className="mt-2 font-semibold">
							Информация о покупателе
						</p>
						<p>
							<span className="font-semibold">Ф.И.О.:</span>
							{data?.cardName}
						</p>
					</div>
					<div></div>
				</div>
			</div>

			<div className="mb-6 mt-5">
				<h2 className="text-center font-semibold mb-2 text-xl">
					Позиции стекла
				</h2>
				<table className="w-full border-collapse border border-black text-lg">
					<thead>
						<tr className="print:bg-[#81857B] text-white font-semibold text-lg bg-[#81857B]  print-bg-color">
							<th className="border border-black px-2 py-1">№</th>
							<th className="border border-black px-2 py-1">
								Товар
							</th>

							<th className="border border-black px-0.5 py-0.5">
								Штук
							</th>

							<th className="border border-black px-0.5 py-0.5">
								Кв.м
							</th>
						</tr>
					</thead>
					<tbody>
						{data?.documentLines.map((item, idx) => {
							return (
								<tr className=" font-semibold text-lg   print-bg-color">
									<td className="border border-black  px-2 py-1 text-center">
										{idx + 1}
									</td>
									<td className="border border-black  px-2 py-1">
										{item.itemDescription}
									</td>

									<td className="border border-black  px-0.5 py-0.5  text-center">
										{numberWithSpacesIntl(
											item.quantity / item.kvmetr,
										) || '-'}
									</td>
									<td className="border border-black  px-0.5 py-0.5  text-center">
										{numberWithSpacesIntl(item.quantity)}
									</td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>

			<div className="flex  mt-10">
				<span className="font-semibold text-xl">
					Комментарий: {data?.comments}
				</span>
			</div>
		</div>
	)
}

export default MarshrutPage
